/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Unit_KgInputs */

const vi_agri_unit_kg = /** @type {(inputs: Agri_Unit_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kg`)
};

/**

* @param {Agri_Unit_KgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_unit_kg = /** @type {((inputs?: Agri_Unit_KgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Unit_KgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_unit_kg(inputs)
});